import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Tooltip, Legend);

function Mixedchart({ follower_trending, digg_trending }) {
    const { t } = useTranslation();
    const [mixedChartData, setMixedChartData] = useState(null);
    const [mixedChartOptions, setMixedChartOptions] = useState(null);
    
    useEffect(() => {
        if (!follower_trending && !digg_trending) return;

        var data = follower_trending;
        if (digg_trending) {
            data = digg_trending;
        }

        const labels = data.filter(d => d.legend === "Followers" || d.legend === "Likes").map(d => d.axis_x);
        const barData = data.filter(d => d.legend === "Followers" || d.legend === "Likes").map(d => d.axis_y);
        const lineData = data.filter(d => d.legend === "Followers Increment" || d.legend === "Likes Increment").map(d => d.axis_y);

        setMixedChartData({
            labels,
            datasets: [
                {
                    type: "line",
                    label: follower_trending ? "Followers" : "Likes",
                    data: lineData,
                    borderColor: "#E04ACB",
                    backgroundColor: "#E04ACB",
                    fill: true,
                    tension: 0.3,
                    yAxisID: "y",
                    pointRadius: 0,
                    pointHoverRadius: 4,
                },
                {
                    type: "bar",
                    label: follower_trending ? "Followers Increment" : "Likes Increment",
                    data: barData,
                    backgroundColor: "#4F70FD",
                    yAxisID: "y2",
                }
            ]
        });

        setMixedChartOptions({
            responsive: true,
            interaction: {
                mode: "index",
                intersect: false,
            },
            stacked: false,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: { enabled: true },
                datalabels: { display: false },
                title: {
                    display: true,
                    text: t("Trend of Followers"),
                },
            },
            scales: {
                y: {
                    type: "linear",
                    position: "left",
                    title: {
                        display: true,
                        text: follower_trending ? "Followers" : "Likes",
                    },
                    ticks: {
                        callback: value => {
                            if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                            if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                            return value;
                        }
                    },
                    grid: {
                        drawOnChartArea: true,
                    }
                },
                y2: {
                    type: "linear",
                    position: "right",
                    title: {
                        display: true,
                        text: follower_trending ? "Followers Increment" : "Likes Increment",
                    },
                    ticks: {
                        callback: value => {
                            if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                            if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                            return value;
                        }
                    },
                    grid: {
                        drawOnChartArea: false,
                    }
                },
                x: {
                    ticks: {
                        maxRotation: 45,
                        minRotation: 45
                    }
                }
            }
        });
    }, [follower_trending, digg_trending, t]);

    return (
        <Fragment>
            {mixedChartData && mixedChartOptions && (
                <Chart type="bar" data={mixedChartData} options={mixedChartOptions} />
            )}
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Mixedchart);